<template>


            <a-curvedimage
            :dataKind="fish.fishKind"
            :src="fish.blueAssetId"  
            :height="fish.height" 
            :radius="fish.radius" 
            :theta-length="fish.theta"
            :id="fish.key"
            :dataPaper="fish.paperAssetId"  
            mixin="basicFish"
            :position="fish.position"
            :rotation="fish.rotation"
            :animation="fish.animation"
            :opacity="fish.opacity"
            >
        </a-curvedimage>
    

</template>

<script>



    export default {
        name: 'fish-component',
        props: ['fish'] 
    }

</script>

